<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     布局模板 MenuSectionLink 组件
  | @Version:   2018-12-28  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <component v-bind="checkLink(to, meta)">
    <slot />
  </component>
</template>

<script>
import { isExternalLink } from '@/utils/common'
export default {
  name: 'MenuSectionLink',
  props: {
    to: {
      type: String,
      required: true
    },
    meta: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    checkLink(url, meta) {
      if (isExternalLink(url) || meta.blank === 1) {
        return {
          is: 'a',
          href: url,
          target: '_blank'
        }
      }
      // return {
      //   is: 'router-link',
      //   to: url
      // }
      return {
        is: 'div'
      }
    }
  }
}
</script>
